export default {
    name: "ClientLogo",
  };